import init from '../helpers/init'

export default [
  ({ props, state }) => {
    init(props, state)
  }
]
